import angular from 'angular'
import createABAModule from '../createABA/createABA'
import viewABAModule from '../viewABA/viewABA'

import feesDueComponent from './feesDue.component'

export default angular.module('app.pages.admin.adminDashboard.directDebits.feesDue', [createABAModule.name, viewABAModule.name])
  .directive('feesDue', feesDueComponent)
